<template>
  <div class="container p-6 has-text-centered has-background-white">
    <div class="image" style="width:300px;margin: 0 auto">
      <img src="/images/TC wired for Gant Travel.png" />
      <img src="/images/SVGs/Plane_with_Clouds.svg" alt="Book Travel with Trip Circuit">
    </div>

    <div style="max-width:600px;margin: 0 auto">
    <p class="is-size-4 mb-2 has-text-weight-bold">Email Verification</p>
    <p class="is-size-6 mb-4">{{ message }}</p>

    <p class="text-center register ubuntu" v-if="isEmailValidated">
            <a
              href="/login"
              id="signup"
              class="teal-text"
              > Click here to Login</a
            >
          </p>
    </div>
    
   
  </div>
</template>

<script>
export default {
  name: "EmailVerificationSuccess",
  props: {},
  data() {
    return {
      message: 'Verifying your email...',
      loading: false,
      isEmailValidated:false,
    };
  },
  created() {

    var body = {
      token:this.$route.params.token
      };

    this.$app
        .huddleLabsServerCall("profile/register/verify-email", body)
        .then((result) => {
          if (result.success) {
            this.loading = false;
            this.isEmailValidated= true;
            this.message = 'Your registration is complete. You can now login using your credentials.';

          } else {
            this.loading = false;
            if(result.emailValidated)
             this.isEmailValidated= true;

            if(result.message)
            this.message = result.message;
          else
            this.message = 'Email verification failed.';
          }
        }).catch((error) => {
            this.loading = false;

            this.message = 'An error occurred while verifying your email.';

            console.log(error);
          });

   
  },
  
  methods: {},
};
</script>

<style scoped>
.image {
  padding: 15px;
  padding-right: 20px;
}</style>
